<template>
    <div class="question-box">
        <p :class="['question-text', { 'question-text--flash': isFlashing }]">
            {{ question }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, ref, watch } from 'vue';

    interface Props {
        readonly question: string;
    }

    const props = defineProps<Props>();

    const isFlashing = ref(false);
    let flashTimeout: ReturnType<typeof setTimeout> | null = null;

    const triggerFlash = () => {
        if (flashTimeout) {
            clearTimeout(flashTimeout);
        }

        isFlashing.value = false;

        requestAnimationFrame(() => {
            isFlashing.value = true;
            flashTimeout = setTimeout(() => {
                isFlashing.value = false;
                flashTimeout = null;
            }, 220);
        });
    };

    watch(
        () => props.question,
        () => {
            triggerFlash();
        }
    );

    onBeforeUnmount(() => {
        if (!flashTimeout) {
            return;
        }

        clearTimeout(flashTimeout);
    });
</script>

<style scoped>
    .question-box {
        position: absolute;
        top: 77%;
        left: 20px;
        right: 20px;
        background: #0088a0;
        backdrop-filter: blur(5px);
        border-radius: 20px;
        padding: 15px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(255, 255, 255, 0.2);
        z-index: 15;
    }

    .question-text {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        margin: 0;
        line-height: 1.3;
    }

    .question-text--flash {
        animation: question-text-flash 220ms ease-out;
    }

    @keyframes question-text-flash {
        0% {
            opacity: 0.45;
            transform: scale(0.9);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
</style>
